import { Injectable, Type } from '@angular/core';
import { toast } from 'ngx-sonner';
import type { ExternalToast, PromiseData, PromiseT } from 'ngx-sonner';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  show(message: string, data?: ExternalToast): string | number {
    return toast(message, data);
  }

  success(message: string, data?: ExternalToast): string | number {
    return toast.success(message, data);
  }

  error(message: string, data?: ExternalToast): string | number {
    return toast.error(message, data);
  }

  info(message: string, data?: ExternalToast): string | number {
    return toast.info(message, data);
  }

  warning(message: string, data?: ExternalToast): string | number {
    return toast.warning(message, data);
  }

  loading(message: string, data?: ExternalToast): string | number {
    return toast.loading(message, data);
  }

  promise<ToastData>(
    promise: PromiseT<ToastData>,
    data?: PromiseData<ToastData>,
  ): string | number | undefined {
    return toast.promise(promise, data);
  }

  custom<T>(component: Type<T>, data?: ExternalToast): string | number {
    return toast.custom(component, data);
  }

  dismiss(id?: number | string): string | number | undefined {
    return toast.dismiss(id);
  }
}
